import { Directive, Input, HostListener } from '@angular/core';
import { Component, ElementRef, ViewChild, AfterViewInit} from '@angular/core';


@Directive({
  selector: '[appAutoTab]'
})
export class AutoTabDirectiveDirective {

  @Input('appAutoTab') appAutoTab
  keypressed: number;
  @ViewChild('input1') inputEl:ElementRef;
  cal: any;
  @HostListener('input', ['$event.target']) onInput(nextinput) {
    
    const length = nextinput.value.length
    const maxLength = nextinput.attributes.maxlength.value
    if (length >= maxLength) {
      this.appAutoTab.focus()
      this.cal=nextinput
    }
  }

 
}

